import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppBreadcrumbModule } from '@coreui/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AppMaterialModule } from '../../../app-material/app-material.module';
import { DatePickerModule } from '../../datePicker/date-picker/date-picker.module';
import { PdfExporterModule } from '../../pdf-exporter/pdf-exporter.module';
import { StatisticsCardComponent } from './statistics-card.component';



@NgModule({
  declarations: [StatisticsCardComponent],
  imports: [
    CommonModule,
    AppMaterialModule,
    ChartsModule,
    TranslateModule,
    AppBreadcrumbModule,
    TranslateModule,
    NgxDaterangepickerMd,
    DatePickerModule,
    PdfExporterModule
  ],
  exports: [StatisticsCardComponent]
})
export class StatisticsCardModule { }
